import { ClockInnerRing } from './ClockInnerRing';
import { HourHand, type HourHandProps } from './HourHand';

export const Clock = (props: HourHandProps) => (
  <>
    <ClockInnerRing />
    <HourHand {...props} />
  </>
);
